// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const Start = ({ size, stroke, fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="2px"
    >
      <rect x="1" y=".8" width="16.3" height="46.2" />
      <polygon points="46.8 1.4 17.6 23.9 46.8 46.4 46.8 1.4" />
    </svg>
  );
};
